module.exports = window["MaterialUI"].Checkbox;